import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface PoupState {
  isOpenImportProduct?: boolean
}

const initialState: PoupState = {
  isOpenImportProduct: false,
}

export const poupDucks = createSlice({
  name: 'poup',
  initialState,
  reducers: {
    datMoNhapSanPham: (state, action: PayloadAction<any>) => {
      state.isOpenImportProduct = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  datMoNhapSanPham,
}: any = poupDucks.actions

export default poupDucks.reducer
